export const css = {
	root: '_2bQjFl6E',
	titleBlock: '_1swy4UWo',
	title: '_2AckzAoy',
	eyebrow: '_1usIxilA',
	openCloseIcon: '_2YM2M2z0',
	close: 'W5ArsXeN',
	topicgroup: '_7TK4_ptI',
	item: '_18z0HrI_',
	setTitleBlock: '_3BKQrDRJ',
	emptyTitleBlock: '_1u7pEqwN',
	actionBlock: '_1JRzTc4a',
	setTitle: '_1cWoVRgf',
	setProgress: 'gjJj8-Z0',
	setProficiency: '_1OeOrIwt',
	accordionLegend: '_1-4FA-kh',
	accordionLegendPlaceholder: 'NDc2vQi9',
	accordionLegendProgress: '_37s5h5iP',
	accordionLegendProficiency: '_28TCiDWn',
	accordionBody: 'LHK80ejs',
	itemWrapper: '_1BIC6imu',
	completed: 'b66MWnOS',
	shortDesc: '_2h1r9EUH',
	truncate: '_39x5y-2D',
	status: '_3kXGj514',
	progressBar: '_1vnsjW0N',
	whiteIcon: 'sd2nT9Ru',
	openTitle: '_2VwhQQdx',
	closedTitle: '_2OKlH_EV',
	statusLine: '_6bMoII8l',
	' _key': 'certwise-theme/certwise/book-widgets/topicaccordion'
};

export default css;
